import { render, staticRenderFns } from "./TemplatePdfProject.vue?vue&type=template&id=1d6b3884&"
import script from "./TemplatePdfProject.vue?vue&type=script&lang=js&"
export * from "./TemplatePdfProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports